{
  "title": "Shaxsiy profil",
  "info": "Shaxsiy ma’lumotlar",
  "idCopy": "ID nusxalash",
  "copied": "ID nusxalandi",
  "copyFailed": "ID nusxalanmadi",
  "name": "Ism",
  "surname": "Familiya",
  "birth": "Tug‘ilgan sana",
  "gender": "Jins",
  "chooseGender": "Jinsni tanlang",
  "male": "Erkak",
  "female": "Ayol",
  "save": "Saqlash",
  "saved": "Ma’lumot saqlandi",
  "missing": "Barcha shaxsiy ma’lumotlarni to‘ldiring.",
  "failed": "Ma’lumot saqlanmadi.",
  "alreadySaved": "Shaxsiy ma’lumotlar tasdiqlanib, qulflangan.",
  "confirmTitle": "Tasdiqlang",
  "confirmText": "Ma’lumotlaringiz to‘g‘riligini tasdiqlang. Keyin o‘zgartirish uchun administrator roziligi kerak.",
  "verify": "Tasdiqlash",
  "back": "Orqaga",
  "contacts": "Aloqa ma’lumotlari",
  "linked": "Ulangan",
  "notLinked": "Ulanmagan",
  "unverified": "Tasdiqlanmagan",
  "manage": "Boshqarish",
  "telegram": "Telegram",
  "unavailable": "Mavjud emas",
  "phone": "Telefon raqami",
  "email": "E-pochta",
  "change": "O‘zgartirish so‘rovi",
  "pending": "So‘rov ko‘rib chiqilmoqda.",
  "requestTitle": "Ma’lumotlarni o‘zgartirish",
  "changeHelp": "O‘zgartirish uchun administrator tasdig‘i kerak.",
  "reason": "O‘zgartirish sababi",
  "submit": "So‘rov yuborish",
  "noChanges": "O‘zgarish yo‘q.",
  "changeFailed": "So‘rov yuborilmadi.",
  "changeSent": "So‘rov administratorga yuborildi.",
  "support": "Qo‘llab-quvvatlash",
  "age": "Tug‘ilgan sanani to‘g‘ri kiriting.",
  "loggingOut": "Chiqilmoqda...",
  "logout": "Hisobdan chiqish"
}
